import { takeLatest } from 'redux-saga/effects';
import Raven from 'raven-js';

import {
  SEND_REGISTRATION_INFORMATION_FROM_URL,
  SEND_STANDARD_REGISTRATION_INFORMATION
} from 'src/app/redux/actions/registrationTracker';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import getReturnUrl from 'src/app/api/getReturnUrl';


const sendRegistrationEvent = ({ mpUserId, emailOriginId, registrationSourceId }) => {
  window.gptr('send', 'registrationinformation', {
    mpUserId,
    emailOriginId,
    registrationSourceId
  });
};

function sendNonStandardRegistrationEvent() {
  const mpUserId = getWindowSearchParam('mpUserId');
  const emailOriginId = getWindowSearchParam('emailOriginId');
  const registrationSourceId = getWindowSearchParam('registrationSourceId');

  if (typeof window.gptr !== 'function') {
    Raven.captureException('Tracker function not found');
    window.location.replace(getReturnUrl());
  } else {
    window.gptr('set', 'callback', () =>  window.location.replace(getReturnUrl()));

    sendRegistrationEvent({
      mpUserId,
      emailOriginId,
      registrationSourceId
    });

    // This line is to prevent situation when oldTracker is not loaded or _gpu cookie does not exists
    // Can delete after oldTracker depracation
    setTimeout(() =>  window.location.replace(getReturnUrl()), 350);
  }
}

function sendStandardRegistrationEvent({ payload }) {
  const { mpUserId, emailOriginId, registrationSourceId } = payload;

  if (typeof window.gptr!=='function') {
    Raven.captureException('Tracker function not found');
  } else {
    sendRegistrationEvent({
      mpUserId,
      emailOriginId,
      registrationSourceId
    });
  }
}

export default [
  takeLatest(SEND_REGISTRATION_INFORMATION_FROM_URL, sendNonStandardRegistrationEvent),
  takeLatest(SEND_STANDARD_REGISTRATION_INFORMATION, sendStandardRegistrationEvent)
];
